
	export default {
		props: ['title', 'subtitle', 'gridData', 'stackData'],
		data(){
			return {
				gridView: true
			}
		}
	}
